import { render, staticRenderFns } from "./KibanaConv.vue?vue&type=template&id=15f3d270&scoped=true&"
import script from "./KibanaConv.vue?vue&type=script&lang=js&"
export * from "./KibanaConv.vue?vue&type=script&lang=js&"
import style0 from "./KibanaConv.vue?vue&type=style&index=0&id=15f3d270&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f3d270",
  null
  
)

export default component.exports